import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11a53bac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": $props.editVisible,
    width: "500",
    "show-close": false,
    "destroy-on-close": "",
    "before-close": $setup.handleClose
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */),
        _createVNode(_component_el_icon, {
          size: "18",
          style: {"cursor":"pointer"},
          onClick: $setup.handleClose
        }, {
          default: _withCtx(() => [
            _createVNode($setup["CloseBold"])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, { onClick: $setup.handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.confirm
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          shadow: "never",
          style: {"width":"460px"}
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString($setup.subTitle), 1 /* TEXT */)
          ]),
          default: _withCtx(() => [
            ($setup.subTitle === '回调API')
              ? (_openBlock(), _createBlock(_component_el_form, {
                  key: 0,
                  model: $setup.callbackForm,
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "用户在线状态回调" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.callbackForm.onlineStatus,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.callbackForm.onlineStatus) = $event)),
                          placeholder: "请输入回调用户在线状态地址"
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_el_form_item, { label: "语音通话状态回调" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $setup.callbackForm.voiceStatus,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.callbackForm.voiceStatus) = $event)),
                          placeholder: "请输入回调语音通话状态地址"
                        }, null, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["model"]))
              : (_openBlock(), _createBlock(_component_el_form, {
                  key: 1,
                  ref: "formRef",
                  model: $setup.formData,
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentField, (field) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: field.model
                      }, [
                        (field.model !== 'configType' && field.model !== 'pushPlateform')
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              label: field.label,
                              prop: field.props,
                              rules: field.ruler
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: $setup.formData[field.model],
                                  "onUpdate:modelValue": ($event: any) => (($setup.formData[field.model]) = $event),
                                  placeholder: field.placeholder
                                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "prop", "rules"]))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["model"]))
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model-value"]))
}